import { put, call, delay } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadEventStatusFailed,
  loadEventStatusSuccessful,
  loadEventStatusBegin,
} from '../actions';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadEventStatusList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
    } = payload;
    const pool = {
      limit,
      page,
    };
    yield delay(LOADING_DELAY);
    const url = `${BACKEND_URL}/error-levels`;
    yield put(loadEventStatusBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      data.result = data.data;
      yield put(loadEventStatusSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadEventStatusFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadEventStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
